import { CommandPayload } from "src/data/commands";

import { Device } from ".";

export type MdmCommand = {
    id: number;
    fingerprint: string;
    // null for GroupCommands
    device: Device | null;
    created: string;
    creator: string;
    comment: string | null;
    origin: string;
    payload: CommandPayload;
    updated: string;
    status: MdmCommandStatus;
    statuses?: Record<MdmCommandStatus, number>;
    report: string | null;
};

export type MdmCommandStatus = "unknown" | "pending" | "running" | "successful" | "failed" | "received" | "ignored" | "queued";

export const DeviceMdmCommandStatusIcon = {
    unknown: "fa-solid fa-calendar-days",
    pending: "fa-solid fa-hourglass-start",
    running: "fa-solid fa-arrows-rotate",
    successful: "fa-solid fa-check",
    failed: "fa-solid fa-xmark",
    received: "fa-solid fa-database",
    ignored: "fa-solid fa-ban",
    queued: "fa-solid fa-hourglass",
};

export enum MdmCommandOrigin {
    DeviceOrigin = "device/",
    GroupOrigin = "group/",
}

export const MdmCommandOriginIcon = {
    [MdmCommandOrigin.DeviceOrigin]: "fa-solid fa-desktop",
    [MdmCommandOrigin.GroupOrigin]: "fa-solid fa-sitemap",
};

export enum ComplexCommandNames {
    StartPackage = "startPackage",
    StopPackage = "stopPackage",
    UninstallPackage = "uninstallPackage",
}
